// removed by extract-text-webpack-plugin
module.exports = {"page":"_1uqktWUPoBwkAqk9mCTrz7","wrap":"_3TtZzNghBUv2yVKpUj4JbY","cntwrap":"_2kv-4wL1OdQt_sfhG9Bp1J"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/pages/LinkEpicAccount.scss
// module id = 2946
// module chunks = 0